/**
 * Test IDs for QA automation.
 */
export const testIds = {
  tripSeparationToolSeparate: "trip-separation-tool-separate",

  tripSeparationToolShipmentDropTarget: "trip-separation-tool-shipment-drop-target",
} as const;
